// extracted by css-extract-rspack-plugin
export default {"orderedList":"content-editor-plugin-ordered-list-OrderedList-orderedList-08a249ba"};